import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from '../../config';
import { SkladisteService } from './skladiste.service';

@Component({
  selector: 'app-skladiste',
  templateUrl: './skladiste.component.html',
  styleUrls: ['./skladiste.component.scss'],
  providers: [SkladisteService],
})

export class SkladisteComponent implements OnInit {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  stanjeSkladista: any;
  svaSkladista: any = [];
  idposlovnica: any = undefined;
  poruka: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private _skladisteService: SkladisteService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    this.svaSkladista = [{ idposlovnica: undefined, po_naziv_prikaz: 'SVE' }];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().stanjeSkladista;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSkladista_Pekar_i_Tomo();
    this.dohvatiStanjeSkladista();
  }

  dohvatiSkladista_Pekar_i_Tomo() {
    this._skladisteService.dohvatiSkladista_Pekar_i_Tomo({}).subscribe((res) => {
      //console.log('SKLADIŠTA: ', res);
      this.svaSkladista = [];
      this.svaSkladista = [{ idposlovnica: undefined, po_naziv_prikaz: 'SVE' }];
      if (res.success == true) {
        for (let i = 0; i < res.data.length; i++) {
          this.svaSkladista.push({
            idposlovnica: res.data[i].idposlovnica,
            po_naziv_prikaz: res.data[i].po_naziv_prikaz
          });
        }
        //console.log('SVA SKLADIŠTA:', this.svaSkladista);
      }
    });
  }

  promjenaSkladista(e){
    //console.log(e);
    //console.log(e.value);
    this.idposlovnica = e.value;
    this.dohvatiStanjeSkladista();
  }

  dohvatiStanjeSkladista() {
    this.stanjeSkladista = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      idposlovnica: this.idposlovnica
    }
    //console.log(podaciZaSlanje);
    this._skladisteService.stanjeSkladista(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        if (res.data.length == 0) {
          this.poruka = 'Nema podataka!';
        } else {
          this.poruka = 'Učitavanje...';
        }
        for (let data of res.data) {
          this.stanjeSkladista.push({
            sifra: data.po_sifra,
            naziv: data.po_naziv,
            naziv_firme: data.naziv_firme,
            komada: data.komadstanje,
            paleta: data.paleta,
            sifraArtikla: data.ar_sifra,
            nazivArtikla: data.ar_naziv,
            datumPromjene: moment(data.za_datumizmjene).format('DD.MM.YYYY.'),
          });
        }
        //console.log(this.stanjeSkladista);
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
}
